<template>
  <div>
    <div class="row login-page p-0 m-0">
      <div class="col-lg-8 p-0 m-0 reght-area d-flex flex-column">
        <h1 class="text-center mt-5">{{text_lang.title}}</h1>
        <img src="../assets/images/logo.svg" alt="StoneBox" />
      </div>
      <div class="col-lg-4 p-0">
        <div class="">
          <Loading v-show="isLoading" />
        </div>
        <div class="left-area px-5 py-3 bg-whigt">
          <div class="my-5">
            <h1 class="mt-5">{{text_lang.welcome}} ;)</h1>
          </div>
          <!-- <span class="describe">
            <strong>Stonebox</strong>, sua solução completa para gerencia de blocos de rochas naturais!
          </span> -->
          <form class="divider-top my-5 py-5">
            <legend class="mb-3">{{text_lang.acsess}}:</legend>
            <div class="form-group">
              <input
                type="email"
                v-model="email"
                placeholder="E-mail"
                class="form-control"
                id="input-email"
                aria-describedby="emailHelp"
              />
            </div>
            <div class="form-group my-4">
              <input
                type="password"
                v-model="password"
                class="form-control"
                :placeholder="is_pt_br ? 'Senha' : 'Password'"
                id="input-password"
              />
            </div>

            <button @click.prevent="login" class="btn btn-dark btn-block">
              {{text_lang.sign_in}}
            </button>
            <div
              v-show="mensagemError"
              class="alert alert-danger mt-3"
              role="alert"
            >
              {{ mensagemError }}
            </div>
          </form>
          <form
            class="
              d-flex
              flex-column
              justify-content-center
              mt-5
              p-4
              divider-top
            "
          >
            <span class="mt-3 text-center">
              {{text_lang.invite_text}}
            </span>
            <button @click.prevent="visitPage()" class="btn mt-4 btn-sm btn-outline-dark">
              {{text_lang.btn_invite}}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import auth from "../utils/auth";
import Loading from "../components/utils/AnimateLoad";
import DataPt from '../data/pt-br/login'
import DataEn from '../data/en-us/login'
export default {
  name: "Login",
  components: { Loading },
  data() {
    return {
      password: "",
      email: "",
      mensagemError: "",
      isLogged: false,
      isLoading: false,
    };
  },

  computed: {
    text_lang(){
      return this.$store.getters.is_pt_br ? DataPt : DataEn
    },

    is_pt_br(){
      return this.$store.getters.is_pt_br 
    }
  },

  watch: {
    mensagemError() {
      if (this.mensagemError.length > 0) {
        setTimeout(() => {
          document.querySelector(".alert").classList.add("alert-remove");
        }, 2000);
        setTimeout(() => {
          this.mensagemError = "";
          document.querySelector(".alert").classList.add("alert-remove");
        }, 3000);
      } else document.querySelector(".alert").classList.add("alert-remove");
    },
  },
  methods: {
    // ...mapActions("user", ["setUserLogin"]),
    async login() {
      this.isLoading = true;
      this.isLogged = await auth.login(this.email, this.password);
      if (this.isLogged) {
        if (this.$route.query && this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect);
        } else {
          // this.setUserLogin(this.isLogged);
          this.$router.push({ name: "Home" });

          this.isLoading = false;
        }
      } else {
        this.isLoading = false;
        this.mensagemError = this.is_pt_br ?  "Erro na autenticação" : 'Authentication error';
      }
    },

    visitPage(){
       this.$router.push({ name: "StoneList" });
    }
  },
};
</script>

<style lang="scss" scoped>
.loading_area {
  width: 90%;
  height: 90%;
}
h1 {
  font-weight: 300;
}
.left-area {
  padding: 0;
  height: 100vh;
  background-color: #ffffff;
  color: #333333;
  span {
    // color: #3f67cc;
    // font-size: 1px;
    font-weight: 300;
  }
  .describe {
    font-size: 22px;
  }
  .btn {
    // background-color: #333333;
    border-radius: 0.4rem !important;
    // color: #ffffff;
  }
}
.reght-area {
  padding: 0;
  background-color: #f1f1f1f1;
  img {
    height: 380px;
    margin-top: 18vh;
  }
  height: 100vh;
}
.login-page {
  height: 100vh;
  width: 100vw;
  .form-control {
    border-radius: 0.4rem !important;
    border: 1px solid #333333;
    input {
      ::placeholder {
        color: #333333;
      }
    }
    input:focus {
      outline-style: none;
      box-shadow: none;
      border-color: transparent;
      background-color: black;
    }
  }
}
@media (max-width: 770px) {
  .reght-area {
    display: none !important;
    //   height: 200px;
    //   img{
    //     height: 50px;
    //     margin-top: 1vh;
    // }
    // h1{
    //   font-size: 22px;
    // }
  }
}

.alert-remove {
  animation: disove 1000ms;
}

@keyframes disove {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
